import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SeoReportDetails } from '../../../services/seo.service';

interface SeoReportDetailsState {
  report: SeoReportDetails | null;
  loading: boolean;
  creatingAuditUrl: string | null;
}

const initialState: SeoReportDetailsState = {
  report: null,
  loading: true,
  creatingAuditUrl: null,
};

const seoReportDetailsSlice = createSlice({
  name: 'seoReportDetails',
  initialState,
  reducers: {
    setSeoReportDetails: (state, action: PayloadAction<SeoReportDetails | null>) => {
      state.report = action.payload;
    },
    setSeoReportLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSeoReportCreatingAuditUrl: (state, action: PayloadAction<string | null>) => {
      state.creatingAuditUrl = action.payload;
    },
    resetSeoReportDetailsState: () => initialState,
  },
});

export const {
  setSeoReportDetails,
  setSeoReportLoading,
  setSeoReportCreatingAuditUrl,
  resetSeoReportDetailsState,
} = seoReportDetailsSlice.actions;

export default seoReportDetailsSlice.reducer;
